// Module
var code = "<div class=\"search-field\"> <span class=\"field-name\">{{name}}</span> <span class=\"field-type\">{{type}}</span> </div> ";
// Exports
export default code;